<script>
import qs from 'qs'
import { getIrrInfo } from 'api/index'
import ScrollTable from './scrollTable'
export default {
  name: 'IrrCalculator',
  components: {
    ScrollTable
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ''
    },
    insuredAge: {
      type: Number,
      default: 0
    },
    startYear: {
      type: Number,
      default: 0
    },
    profitProduct: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    // 缓存
    this.irrCache = {}
    this.irrCacheKey = ''
    return {
      isShow: false,
      list: []
    }
  },
  methods: {
    fetch () {
      const {
        uuid,
        profitProduct: { productId, bonus, rate }
      } = this
      const parameter = {
        bonus: {},
        rate: {},
        uuid,
        productId
      }
      bonus && (parameter.bonus.value = bonus.value)
      rate && (parameter.rate.value = rate.value)
      if (!productId) return Promise.reject()
      this.irrCacheKey = this.getCacheKey(productId, bonus, rate)
      const cacheData = this.irrCache[this.irrCacheKey]
      if (cacheData) {
        return Promise.resolve({
          success: true,
          data: cacheData
        })
      }
      return getIrrInfo(
        qs.stringify({
          jd: JSON.stringify(parameter)
        })
      )
    },
    async handleOpen () {
      try {
        const { success, data } = await this.fetch()
        if (!success || !Array.isArray(data.dataList)) return
        this.irrCache[this.irrCacheKey] = data
        this.list = this.formatData(data)
        this.isShow = true
      } catch (err) {
        console.log('err', err)
      }
    },
    formatData (data) {
      // [IRR]
      let irrValues = []
      if (this.irrCache[this.irrCacheKey]._irr) {
        irrValues = this.irrCache[this.irrCacheKey]._irr
      } else {
        irrValues = this.getIrrValues(data)
        this.irrCache[this.irrCacheKey]._irr = irrValues
      }
      const dataList = JSON.parse(JSON.stringify(data.dataList))
      dataList.push({
        key: '_irr',
        name: '年化复利(IRR)',
        values: irrValues
      })
      // [领取]<都为0时>不显示
      let outputIndex = 0
      dataList.forEach(
        (item, index) => item.key === 'output' && (outputIndex = index)
      )
      if (dataList[outputIndex]) {
        if (dataList[outputIndex].values.every(item => item === 0)) {
          dataList.splice(outputIndex, 1)
        }
      }
      dataList.forEach(item => {
        item.values = item.values.map(v => {
          return item.key === '_irr' && v ? `${v}%` : this.formatValue(v)
        })
      })
      return dataList
    },
    getIrrValues (data) {
      const { ageIndex, dataList, irrCalculate, cashCalculate } = JSON.parse(
        JSON.stringify(data)
      )
      // 现金流
      // = 交费 + 领取 + 额外领取（现金价值｜账户价值｜生存总利益）
      // *交费｜领取 => 使用累计值
      // *额外领取 => 使用当年
      const inputList = dataList.filter(item => item.key === 'input')[0]
      const outputList = dataList.filter(item => item.key === 'output')[0]
      const extraList = dataList.filter(
        item => item.key !== 'input' && item.key !== 'output'
      )[0]
      if (!inputList || !outputList) return
      const valuesLen = inputList.values.length
      const isCashCal = cashCalculate === 1
      let cashValues = Array.from(
        { length: valuesLen },
        (i, index) => outputList.values[index] - inputList.values[index]
      )
      const lastIndex = cashValues.length - 1
      const isLast = ageIndex >= lastIndex
      const startIndex = isLast ? lastIndex : ageIndex
      let irrValues = Array.from({ length: cashValues.length }, i => undefined)
      // 年初（上年末）到年末的差
      if (isCashCal) {
        cashValues = cashValues.reduce(
          (accumulate, item, index) => {
            accumulate.push(
              outputList.values[index] - (inputList.values[index + 1] || 0)
            )
            return accumulate
          },
          [-inputList.values[0]]
        )
      }
      if (irrCalculate === 1 || isLast) {
        // 仅计算最后一年（显示最后一年）
        const tempCashValues = cashValues.slice()
        if (extraList) {
          let accountValue = 0
          let lastValue = tempCashValues[lastIndex]
          if (
            Array.isArray(extraList.values) &&
            !isNaN(extraList.values[lastIndex])
          ) {
            accountValue = extraList.values[lastIndex]
          }
          tempCashValues[lastIndex] = lastValue + accountValue
        }
        irrValues[lastIndex] = this.IRRCalc(tempCashValues)
      } else {
        // 逐年
        // 计算方式导致增加1年
        const fixIndex = isCashCal ? 1 : 0
        irrValues = irrValues.map((item, index) => {
          const idx = index + 1 + fixIndex
          if (idx < startIndex) return item
          const tempCashValues = cashValues.slice(0, idx)
          const tempLastIndex = tempCashValues.length - 1
          if (extraList) {
            let accountValue = 0
            let lastValue = tempCashValues[tempLastIndex]
            const extraIndex = tempLastIndex - fixIndex
            if (
              Array.isArray(extraList.values) &&
              !isNaN(extraList.values[extraIndex])
            ) {
              accountValue = extraList.values[extraIndex]
            }
            tempCashValues[tempLastIndex] = lastValue + accountValue
          }
          return this.IRRCalc(tempCashValues)
        })
      }
      return irrValues
    },
    getCacheKey (productId, bonus, rate) {
      let cacheKey
      let tempBonusKey
      let tempRateKey
      if (bonus) {
        if (bonus.value || bonus.value === 0) {
          tempBonusKey = `bonus_${bonus.value}`
        } else {
          console.warn('bonus缺少默认值')
        }
      }
      if (rate) {
        if (rate.value || rate.value === 0) {
          tempRateKey = `rate_${rate.value}`
        } else {
          console.warn('rate缺少默认值')
        }
      }
      if (tempBonusKey && tempRateKey) {
        cacheKey = `${tempBonusKey}-${tempRateKey}`
      } else {
        cacheKey = tempBonusKey || tempRateKey || 'key'
      }
      return `${productId}-${cacheKey}`
    },
    formatValue (val) {
      return isNaN(val) ? '-' : Math.round(parseFloat(val))
    },
    // 现值
    PVCalc (money, interest, n) {
      return money / Math.pow(1 + interest, n)
    },
    // 内部收益率
    IRRCalc (array) {
      let min = -1.0
      let max = 1.0
      if (array[array.length - 1] > 0) {
        min = 0
      } else {
        max = 0
      }
      let guess = (min + max) / 2
      let lastGuess = 1.0
      let notSame = true
      let NPV = 0
      const MIN_GUESS = 0.0000000000000000001
      do {
        NPV = 0
        guess = (min + max) / 2
        if (Math.abs(lastGuess - guess) < MIN_GUESS) notSame = false
        lastGuess = guess
        array.forEach((item, index) => {
          NPV += this.PVCalc(item, guess, index)
        })
        if (NPV > 0) {
          min = guess
        } else {
          max = guess
        }
      } while (notSame && Math.abs(NPV) > MIN_GUESS)
      const raw = parseFloat(guess * 100).toFixed(2)
      return parseFloat(raw)
    }
  }
}
</script>
<template>
  <div class="irr-wrap">
    <div class="irr-hd">
      <span>
        年化复利测算
        <a
          href="https://promotion.winbaoxian.com/promotionNew/Permanent/tp/index.html?tp=30693&nw=1"
        >
          <i class="iconfont icon-common_problem" />
        </a>
      </span>
      <p>运用IRR专业计算，就可以洞察保险的真实年化利率</p>
    </div>
    <div class="irr-bd assert-r" data-stat-id="irr" @click="handleOpen">
      去测算
    </div>
    <scroll-table
      v-model="isShow"
      title="平均年化复利测算（IRR计算器）"
      :list="list"
      :age-index="insuredAge + startYear"
    />
  </div>
</template>
<style lang="postcss" scoped>
.irr-wrap {
  position: relative;
  padding: 0.36rem 0 0.7rem;
  margin: 0 0.3rem;
  display: flex;
  font-size: 0.28rem;
  align-items: baseline;
  justify-content: space-between;
  &::after {
    top: 0;
    left: 0;
    width: 100%;
    height: 1px; /*no*/
    transform: scaleY(0.5);
    position: absolute;
    background: #d8d8d8;
    content: '';
    pointer-events: none;

    transform-origin: 0 0;
  }
  .irr-hd {
    flex: 1;
  }
  .irr-bd {
    flex: 0 0 1.8rem;
  }
  .irr-hd {
    > p {
      position: absolute;
      color: #999;
      font-size: 0.24rem;
      transform: scale(0.91);
      transform-origin: left top;
    }
    > span {
      display: flex;
      margin-bottom: 0.17rem;
      align-items: center;
      a {
        color: #666;
      }
      i {
        margin-left: 0.12rem;
      }
    }
  }
  .irr-bd {
    padding-right: 0.28rem;
    font-size: 0.24rem;
    color: #2972f1;
    text-align: right;
    &::after {
      border-color: #2972f1;
      width: 6px;
      height: 6px;
      margin-top: -3px;
    }
  }
}
</style>
